function f(t, e) {
  if (t == null) return {};
  var i = {}, r = Object.keys(t), o, n;
  for (n = 0; n < r.length; n++)
    o = r[n], !(e.indexOf(o) >= 0) && (i[o] = t[o]);
  return i;
}
function c(t, e) {
  return c = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, o) {
    return r.__proto__ = o, r;
  }, c(t, e);
}
function p(t, e) {
  t.prototype = Object.create(e.prototype), t.prototype.constructor = t, c(t, e);
}
export {
  p as _,
  f as a
};
//# sourceMappingURL=inheritsLoose-OI-DR2K6.mjs.map
